import axios from 'axios'
import {ALTERAR_DADOS_PASSAGEIROS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function alterarDadosPassageiros(empresaId, pedidoId, dadosPassageiros) {
    const url = `${URL}/passageiro/empresa/${empresaId}/pedido/${pedidoId}/alterar-dados-passageiros`;
    return dispatch => axios.post(url, dadosPassageiros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ALTERAR_DADOS_PASSAGEIROS,
            payload: response
        })
    );
}
